var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactEnteredSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contact-entered-site") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-Contact-detail",
    transform: "translate(-290.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-contact-entered-site",
    transform: "translate(290.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#FFFFFF",
    x: 0.444444444,
    y: 0.444444444,
    width: 15.1111111,
    height: 15.1111111,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(5.066667, 8.032296)",
    stroke: "#090B45",
    strokeLinecap: "round",
    strokeWidth: 1.18518519
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    transform: "translate(2.962963, 1.465333) scale(1, -1) translate(-2.962963, -1.465333) ",
    points: "5.92592593 1.26565425e-14 2.96296296 2.93066667 2.42472709e-12 1.26565425e-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.96296296,
    y1: 0.263999704,
    x2: 2.96296296,
    y2: 7.07881481,
    id: "Path",
    transform: "translate(2.962963, 3.671407) scale(1, -1) translate(-2.962963, -3.671407) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.444444444,4.88888889 L15.5555556,4.88888889 L15.5555556,2.66666667 C15.5555556,1.43936722 14.5606328,0.444444444 13.3333333,0.444444444 L2.66666667,0.444444444 C1.43936722,0.444444444 0.444444444,1.43936722 0.444444444,2.66666667 L0.444444444,4.88888889 Z",
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#090B45",
    cx: 2.66666667,
    cy: 2.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#090B45",
    cx: 5.33333333,
    cy: 2.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#090B45",
    x: 8,
    y: 1.77777778,
    width: 5.33333333,
    height: 1.77777778,
    rx: 0.888888889
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactEnteredSite);
export default __webpack_public_path__ + "static/media/icon-contact-entered-site.ca162c5d9820aa8efea7620a85cdcde1.svg";
export { ForwardRef as ReactComponent };